module.exports = __webpack_public_path__ + "img/1f9a0.74e36c1.svg";